import { render, staticRenderFns } from "./EchartBarHorizontal.vue?vue&type=template&id=4eb953cd"
import script from "./EchartBarHorizontal.vue?vue&type=script&lang=js"
export * from "./EchartBarHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports